/**
 * Shared components — English (t('common.…'))
 */
export default {
	loading: "Loading...",
	loginModal: {
		sloganLine1: " ",
		sloganLine2: " ",
		tabPhone: "Mobile",
		tabEmail: "Email",
		submitBtn: "Login / Register",
		thirdLoginTitle: "Sign in or sign up quickly with a social account",
		thirdLoginDivider: "Sign in with other methods",
		phonePlaceholder: "Enter your mobile number",
		emailPlaceholder: "Enter your email",
		codePlaceholder: "Enter verification code",
		sendCode: "Send code",
		kefuHelp: "Didn't receive the code?",
		invalidEmail: "Please enter a valid email address",
		emailRequired: "Please enter your email",
		phoneRequired: "Please enter your mobile number",
		phoneDigitsOnly: "Please enter numbers only",
		areaCodePlaceholder: "Code",
		selectAreaCode: "Please select a country code",
		captchaRequired: "Please complete the verification challenge",
		codeRequired: "Please enter the verification code",
		codeInvalid: "Please enter a 6-digit verification code",
		turnstileError: "Verification failed. Please try again.",
		turnstileExpired: "Verification expired. Please verify again.",
		turnstileUnsupported: "This browser is not supported. Please try another browser.",
		agreePrefix: "I have read and agree to SeerQ's ",
		agreeService: "Terms of Service",
		agreeAnd: " and ",
		agreePrivacy: "Privacy Policy",
		bindTitle: "Enter your email to bind your account",
		bindDesc: "If you have any questions, please contact customer support.",
		bindBtn: "Bind",
		kefu: "Customer support",
		loginSuccess: "Signed in successfully",
	},
	breadcrumb: {
		home: "Home",
		tutor: "Mentors",
		userCenter: "Personal Center",
		aiChat: "AI Chat",
		chatHistory: "Chat History",
		onlineTest: "Online Tests",
		search: "Search",
		searchPlaceholder: "Superpower",
	},
	teacherService: {
		fahuiTitle: "Ritual Services",
		consultTitle: "Consultation Services",
		originalPrice: "Original {price} points",
		finalPrice: "Final Price",
		orderNow: "Order Now",
		breadcrumb: "Teacher Services",
		detailTitle: "Consultation Service Details",
		mobileDetailTitle: "Service Details",
		solutionTitle: "Solutions",
		reviewsTitle: "Consultation reviews",
		recommendTitle: "Recommended Services",
		freeConsult: "Free Try",
		freeAssistantConsult: "Free assistant consultation",
		scoreCount: "{score} ({count} clients served)",
	},
	pcSearchModal: {
		ariaLabel: "Search",
		placeholder: "Search by creator or mentor name",
		search: "Search",
		back: "Back to home",
		clear: "Clear",
		hotTitle: "Hot searches",
		hotTeachersTitle: "Popular Teachers",
		loading: "Loading...",
		searching: "Searching...",
		noHotTeachers: "No popular mentors yet",
		emptyResults: "No results found. Try another keyword.",
		consultCount: "{count} consultations",
		yearsExperience: "{year} years of experience",
		defaultTeacherName: "Mentor",
		tabs: {
			teacher: "Teachers",
			service: "Services",
			dynamic: "Updates",
			expert: "Expert",
		},
		hotTags: ["Love", "Marriage", "Career"],
		dynamic: {
			more: "More",
			comment: "Comment",
			share: "Share",
		},
	},
	pcHeader: {
		nav: {
			home: "Home",
			square: "Media",
			serviceInstitution: "Discover",
			about: "About Us",
		},
		downloadApp: "Download App",
		loginRegister: "Sign in / Sign up",
		languageSwitch: "Language",
		mall: {
			effectTitle: "By Benefit",
			categoryTitle: "By Product",
			effect: {
				wealth: "Wealth & Prosperity",
				protection: "Protection & Warding",
				relationship: "Relationships & Luck",
				peace: "Peace & Wishes",
				career: "Career & Success",
			},
			category: {
				bracelet: "Lucky Bracelets",
				hangings: "Lucky Hangings",
				necklace: "Lucky Necklaces",
				ornament: "Lucky Ornaments",
				talisman: "Lucky Talismans",
				zodiac: "Zodiac Harmony",
			},
		},
	},
	areaSelect: {
		title: "Place select",
		searchPlaceholder: "Enter region name",
	},
	downloadDialog: {
		name: "SeerQ App",
		desc: "This feature is available in the App. Please open it and sign in to your account.",
		download: "Download App",
		open: "Open App",
	},
};
